"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosComplianceGroupSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosComplianceGroupSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    groupId: zod_1.z.string().min(1),
    name: zod_1.z.string().min(1).max(200),
    description: zod_1.z.string().max(2000).optional(),
    categoryIds: zod_1.z.array(zod_1.z.string()).default([]),
    // GSI active-takedowns SK — numeric flag (1 active, 0 inactive).
    takedownActive: zod_1.z.number().int().min(0).max(1).default(0),
    takedownReason: zod_1.z.string().max(1000).optional(),
    takedownScope: zod_1.z.enum(['own-site', 'marketplace', 'both']).optional(),
}).merge(timestamps_schema_1.TimestampsSchema);
//# sourceMappingURL=compliance-group.schema.js.map